import React from "react";
import { Route, Routes } from "react-router-dom";
import FireOnListComponent from "../components/fire-on/FireOnListComponent";
import EditFireOnListComponent from "../components/fire-on/EditFireOnListComponent";
import AddFireOnItemComponent from "../components/fire-on/AddFireOnItemComponent";
import BoundaryMapComponent from "../components/fire-on/BoundaryMapComponent";
import FireAlarmMonitorComponent from "../components/fire-on/FireAlarmMonitorComponent";
import FireEventLogComponent from "../components/fire-on/FireEventLogComponent";
import BuildingInfoComponent from "../components/fire-on/BuildingInfoComponent";
import FireEquipmentStatusComponent from "../components/fire-on/FireEquipmentStatusComponent";
import FireAlarmSmsLogComponent from "../components/fire-on/FireAlarmSmsLogComponent";
import FireAlarmLogReportComponent from "../components/fire-on/FireAlarmLogReportComponent";
import FireAlarmStatisticsRoutes from "../components/fire-on/statistics/FireAlarmStatisticsRoutes";
import FireAlarmSmsSettingComponent from "../components/fire-on/FireAlarmSmsSettingComponent";
import FireAlarmSettingComponent from "../components/fire-on/FireAlarmSettingComponent";
import UserAccessManagementComponent from "../components/fire-on/UserAccessManagementComponent";
import FireInspectionScheduleRoutes from "../components/fire-on/inspection-schedule/FireInspectionScheduleRoutes";
import FireEquipmentStatusDetailComponent from "../components/fire-on/FireEquipmentStatusDetailComponent";
import FireAlarmLogComponent from "../components/fire-on/FireAlarmLogComponent";

export default function FireOnPage() {
  return (
    <Routes>
      <Route path="/*" element={<FireOnListComponent />} />
      <Route path="/add/*" element={<AddFireOnItemComponent />} />
      <Route path="/edit/*" element={<EditFireOnListComponent />} />
      <Route path="/fire-event-log/:id/*" element={<FireEventLogComponent />} />
      <Route path="/boundary-map/:id/*" element={<BoundaryMapComponent />} />
      <Route
        path="/fire-alarm-monitor/:id/*"
        element={<FireAlarmMonitorComponent />}
      />
      <Route path="/building-info/:id/*" element={<BuildingInfoComponent />} />
      <Route
        path="/fire-equipment-status/:id/*"
        element={<FireEquipmentStatusComponent />}
      />
      <Route
        path="/fire-equipment-status/:id/detail/:equipmentId/*"
        element={<FireEquipmentStatusDetailComponent />}
      />
      <Route
        path="/fire-alarm-sms-log/:id/*"
        element={<FireAlarmSmsLogComponent />}
      />
      <Route
        path="fire-alarm-log/:id/*"
        element={<FireAlarmLogComponent />}
      />
      <Route
        path="fire-alarm-log/:id/report/:historyId/*"
        element={<FireAlarmLogReportComponent />}
      />
      <Route
        path="fire-alarm-statistics/*"
        element={<FireAlarmStatisticsRoutes />}
      />
      <Route
        path="fire-alarm-setting/sms/*"
        element={<FireAlarmSmsSettingComponent />}
      />
      <Route
        path="fire-alarm-setting/*"
        element={<FireAlarmSettingComponent />}
      />
      <Route
        path="fire-inspection-schedule/:id/*"
        element={<FireInspectionScheduleRoutes />}
      />
      <Route
        path="user-access-management/*"
        element={<UserAccessManagementComponent />}
      />
    </Routes>
  );
}
